module.exports = __webpack_public_path__ + "img/ada-badge-2013_jp.0c86238.svg";